import { Col, Modal, Row } from "react-bootstrap";
import PaymentTbl from "../../contants/tables/PaymentTbl";

const PaymentDetailTableModal = ({
  data,
  isOpen,
  handleIsPaymentDetailMdl,
  selectedInvoice
}) => {

  console.log("selectedInvoice", selectedInvoice);

  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        size="lg"
        show={isOpen}
        onHide={handleIsPaymentDetailMdl}
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice Payment Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>
            <Col md={4}>
              <div className="text-sm text-slate-500">Invoice No.</div>
              <div>{selectedInvoice.INVOICE_NO}</div>
            </Col>
            <Col md={4}>
              <div className="text-sm text-slate-500">Invoice Date</div>
              <div>{selectedInvoice.INVOICE_DT}</div>
            </Col>
            <Col md={4}>
              <div className="text-sm text-slate-500">Total Paid Amount</div>
              <div>&#8377; {selectedInvoice.PAID_AMT}</div>
            </Col>
          </Row>
          <PaymentTbl
            data={data}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaymentDetailTableModal;
